export const imagePreviewActionTypes = {
	SET_IMAGE_PREVIEW: 'SET_IMAGE_PREVIEW',
} as const;
